var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "mb14 normal-page" }, [
        _c("div", { staticClass: "from-s" }, [
          _c(
            "div",
            { staticClass: "flex-row flex-col" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["fd:examine:export"],
                      expression: "['fd:examine:export']",
                    },
                  ],
                  staticClass: "mb20",
                  attrs: { size: "small" },
                  on: { click: _vm.getExportData },
                },
                [_vm._v("\n          导出\n        ")]
              ),
              _vm._v(" "),
              _c("formBox", {
                ref: "formBox",
                attrs: { activeName: _vm.activeName },
                on: { confirmData: _vm.confirmData },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "splitLine" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt10" },
          [
            _c("div", { staticClass: "inTotal" }, [
              _vm._v("共 " + _vm._s(_vm.total) + " 条"),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticClass: "mt10",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "row-key": "id",
                  "default-expand-all": "",
                },
                on: { "sort-change": _vm.sortChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "date",
                    "min-width": "150",
                    sortable: "",
                    label: "付款时间",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "bill_types",
                    label: "记录类型",
                    "min-width": "90",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  scope.row.types == 2 ? "warning" : "success",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(scope.row.types == 2 ? "支出" : "收入")
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "num",
                    "min-width": "90",
                    label: "付款金额(元)",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "pay_type",
                    "min-width": "100",
                    label: "支付方式",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.pay_type !== ""
                                  ? scope.row.pay_type
                                  : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "treaty.contract_name",
                    label: "合同名称",
                    "min-width": "120",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "treaty.contract_no",
                    label: "合同编号",
                    "min-width": "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "created_at",
                    label: "申请时间",
                    "min-width": "140",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    "min-width": "120",
                    label: "付款审核状态",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status === 0
                            ? _c(
                                "el-tag",
                                { attrs: { type: "warning", size: "mini" } },
                                [_vm._v(" " + _vm._s(_vm.$t("customer.audit")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 1
                            ? _c(
                                "el-tag",
                                { attrs: { type: "info", size: "mini" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("customer.passed"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 2
                            ? _c(
                                "el-popover",
                                {
                                  attrs: { trigger: "hover", placement: "top" },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("customer.reason")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(scope.row.fail_msg))]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("customer.fail"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.activeName == "1"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "address",
                        fixed: "right",
                        label: _vm.$t("public.operation"),
                        "min-width": "160",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["fd:examine:check"],
                                        expression: "['fd:examine:check']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCheck(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleContract(scope.row, "")
                                      },
                                    },
                                  },
                                  [_vm._v("通过")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.refuse(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("拒绝")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1858052446
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeName == "2"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "address",
                        fixed: "right",
                        label: _vm.$t("public.operation"),
                        "min-width": "180",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["fd:examine:check"],
                                        expression: "['fd:examine:check']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCheck(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                ),
                                _vm._v(" "),
                                scope.row.status !== 0
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: ["fd:examine:edit"],
                                            expression: "['fd:examine:edit']",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleContract(
                                              scope.row,
                                              "edit"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.status !== 0 &&
                                scope.row.invoice_id == 0
                                  ? _c(
                                      "el-dropdown",
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-dropdown-link el-button--text el-button",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.$t("hr.more")) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-menu",
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.withdraw(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("撤回审核 ")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleDelete(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("删除 ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : [
                                      scope.row.status !== 0
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleDelete(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                    ],
                                _vm._v(" "),
                                scope.row.status == 0
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleContract(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("通过")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.status == 0
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.refuse(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("拒绝")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3484555048
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paginationClass" },
              [
                _c("el-pagination", {
                  attrs: {
                    "page-size": _vm.where.limit,
                    "current-page": _vm.where.page,
                    "page-sizes": [10, 15, 20],
                    layout: "total, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.pageChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.title,
            top: "25vh",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "from",
              staticClass: "from",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.reason + "：",
                    "label-width": "90px",
                    prop: "remarks",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: { click: _vm.cancelFn },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.submitFn },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("examine-dialog", {
        ref: "examineDialog",
        attrs: { config: _vm.config },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("operationDialog", {
        ref: "operationDialog",
        attrs: { statusOption: _vm.statusOptions, config: _vm.operationDialog },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          template: false,
          "save-name": _vm.saveName,
          "export-data": _vm.exportData,
        },
      }),
      _vm._v(" "),
      _c("applyForPayment", {
        ref: "applyForPayment",
        attrs: { "form-data": _vm.fromData, paymentType: _vm.paymentType },
        on: { isOk: _vm.getTableData },
      }),
      _vm._v(" "),
      _c("expend-dialog", {
        ref: "expendDialog",
        attrs: { config: _vm.operationDialog },
        on: { isOk: _vm.isOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }